import React from 'react'
import { ORGANIZATION_TYPES, TOrganizationType } from 'pages/Planning/types'
import './organization-type.css'

interface OrganizationTypeProps {
  selectedType: TOrganizationType
  onTypeChange: (type: TOrganizationType) => void
  isDarkMode?: boolean
}

const OrganizationType: React.FC<OrganizationTypeProps> = ({
  selectedType,
  onTypeChange,
  isDarkMode = false,
}) => {
  return (
    <div className={`organization-type-container ${isDarkMode ? 'dark' : 'light'}`}>
      <div className="organization-type-header">
        <h3 className="organization-type-title">Tipo de planejamento</h3>
        <p className="organization-type-description">Escolha como deseja organizar seus estudos</p>
      </div>

      <div className="organization-type-options">
        {ORGANIZATION_TYPES.filter((t) => t.value === 'cycle').map((type) => {
          const isDisabled = false //type.value === 'schedule'
          const isSelected = selectedType === type.value

          return (
            <label
              key={type.value}
              className={`organization-type-option ${isSelected ? 'selected' : ''} ${
                isDisabled ? 'disabled' : ''
              }`}
            >
              <input
                type="radio"
                name="organization-type"
                value={type.value}
                checked={isSelected}
                onChange={() => onTypeChange(type.value)}
                disabled={isDisabled}
              />
              <div className="organization-type-option-content">
                <div className="organization-type-option-header">
                  <span className="organization-type-option-label">{type.label}</span>
                  {isDisabled && <span className="coming-soon-badge">Em breve</span>}
                </div>
                <span className="organization-type-option-description">{type.description}</span>
              </div>
            </label>
          )
        })}
      </div>
    </div>
  )
}

export default OrganizationType
